module.exports = {
  src: __webpack_public_path__ + "assets/images/warning-ico.dbd6151f2ab1d45b.svg",
  width: 32,
  height: 32,
  toString: function() { return __webpack_public_path__ + "assets/images/warning-ico.dbd6151f2ab1d45b.svg"; }
};